import { IconButton } from "@material-ui/core";
import React from "react";

interface ActionButtonProps {
  className: string | undefined;
  onClick: () => void;
  icon: any;
  disabled?: boolean;
}

export const ActionButton = (props: ActionButtonProps) => {
  const {
    className,
    disabled,
    onClick,
    icon,
  } = props;

  return (
    <IconButton disabled={disabled} className={className} aria-label="expand row" size="small" onClick={onClick}>
      {icon}
    </IconButton>
  );
}